import { useState } from "react";
import { createPortal } from "react-dom";
import { F } from "../../theme/tokens";

// ── Toast ─────────────────────────────────────────────────────────────────────

export type AddToast = (m: string, t?: "success" | "error" | "info") => void;

export interface Toast { id: string; message: string; type: "success" | "error" | "info" }

export function ToastList({ toasts }: { toasts: Toast[] }) {
  // Rendered on <body>, outside every other stacking context, so a message is never
  // hidden behind a drawer or a dialog (the verification drawer used to cover it).
  return createPortal(
    <div style={{ position: "fixed", bottom: "24px", right: "24px", zIndex: 99999, display: "flex", flexDirection: "column", gap: "8px", pointerEvents: "none" }}>
      {toasts.map((t) => {
        const colors = { success: { bg: "#e4f5ec", border: "#bbf7d0", fg: "#166534" }, error: { bg: "#fee2e2", border: "#fecaca", fg: "#991b1b" }, info: { bg: "#dbeafe", border: "#bfdbfe", fg: "#1e40af" } };
        const c = colors[t.type];
        return (
          <div key={t.id} style={{ background: c.bg, border: `1px solid ${c.border}`, color: c.fg, borderRadius: "8px", padding: "10px 16px", fontSize: "12px", fontFamily: F, fontWeight: 500, minWidth: "220px", maxWidth: "calc(100vw - 32px)" }}>
            {t.message}
          </div>
        );
      })}
    </div>,
    document.body
  );
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const add = (message: string, type: "success" | "error" | "info" = "success") => {
    const id = Math.random().toString(36).slice(2);
    setToasts((p) => [...p, { id, message, type }]);
    setTimeout(() => setToasts((p) => p.filter((t) => t.id !== id)), 3200);
  };
  return { toasts, add };
}
